import React from 'react';
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  ExclamationOutlined,
} from '@ant-design/icons';
import { defaultData } from '../../../../index';
import { ColumnsType } from 'antd/es/table';
import { DataType } from '../interfaces/interfaces';
import { Button, Switch } from 'antd';
import { ConfirmDelete } from '../../../common/components/ConfirmDelete/ConfirmDelete';

export const validateMessages = {
  required: '${label} is required!',
  types: {
    address: '${label} is not a valid email!',
    number: '${label} is not a valid number!',
  },
};

const getIconForNotification = (status) => {
  switch (status) {
    case 'error': {
      return <ExclamationCircleOutlined style={{ color: defaultData.errorColor }} />;
    }
    case 'success': {
      return <ExclamationOutlined style={{ color: defaultData.colorPrimary }} />;
    }
    default:
      return <ExclamationCircleOutlined style={{ color: defaultData.errorColor }} />;
  }
};

export const showNotification = (notification, message, description, status): void => {
  notification.info({
    message: message,
    description: description,
    placement: 'topLeft',
    icon: getIconForNotification(status),
  });
};

export const notificationMessages = {
  deleteProjectError: 'Не удалось удалить проект',
  enterUniqueEnglishName: 'Введите уникальное название на английском',
  absentXml: 'Отсутствует xml файл',
  errRespXPathProject: 'Не удалось загрузить xPath проекта',
  errRespXPathCheck: 'Не выполнить проверку xPath',
  errSaveXpath: 'Не удалось сохранить xPath',
  errEditProject: 'Не удалось изменить проект',
  errAddProject: 'Не удалось добавить новый проект',
  errUploadXml: 'Не удалось загрузить файл',
  errGetProjects: 'Не удалось загрузить проекты',
  errGetUsers: 'Не удалось загрузить пользователей',
  errChangeUsers: 'Не удалось изменить данные пользователя',
  successSave: 'Изменения успешно сохранены',
  errDeleteUser: 'Невозможно удалить пользователя',
  successDeleted: 'Успешно удален',
  successDeletedDescription:
    // eslint-disable-next-line max-len
    'Пользователь лишен доступа в систему и исключен из списка пользователей. Для отмены действия обратитесь к системному администратору.',
  errAddUser: 'Не удалось добаить нового пользователя',
  successAddUser: 'Пользователь успешно добавлен',
};

export const getColumns = (
  showDrawer: (id: number) => void,
  handleChangeBlocked: (id: number, is_active: boolean) => void,
  handleDelete: (id: number) => void,
) => {
  const columns: ColumnsType<DataType> = [
    {
      title: 'Имя пользователя',
      dataIndex: 'username',
      key: 'username',
      ellipsis: true,
      width: 400,
    },
    {
      title: 'Эл.адрес',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Заблокирован',
      dataIndex: 'is_active',
      key: 'is_active',
      width: 140,
      render: (is_active, obj) => {
        return (
          <Switch checked={!is_active} onChange={() => handleChangeBlocked(obj.id, !is_active)} />
        );
      },
    },
    // {
    //   title: 'Дата создания',
    //   key: 'date_creation',
    //   dataIndex: 'date_creation',
    //   width: 200,
    //   sorter: (a: DataType, b: DataType) => {
    //     const timeStampA = moment(a.date_creation, 'YYYY-MM-DDTHH:mm:ss').unix();
    //     const timeStampB = moment(b.date_creation, 'YYYY-MM-DDTHH:mm:ss').unix();
    //
    //     return timeStampB - timeStampA;
    //   },
    // },
    {
      title: 'Действие',
      key: 'actions',
      dataIndex: 'actions',
      // width: 140,
      render: (actions, obj) => {
        return (
          <div style={{ display: 'flex' }}>
            <Button
              style={{ padding: 0 }}
              onClick={() => showDrawer(obj.id)}
              type='link'
              icon={<EditOutlined />}
            >
              Изменить
            </Button>

            <ConfirmDelete handleDelete={() => handleDelete(obj.id)} placement={'leftTop'}>
              <Button danger type='text' icon={<DeleteOutlined />}></Button>
            </ConfirmDelete>
          </div>
        );
      },
    },
  ];
  return columns;
};
